<template>
  <div v-if="show" :class="[status, { 'tournament-status-indicator': !unstyled }]">
    {{ text }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { TournamentStatus } from '@/model/TournamentStatus'
import { useI18n } from 'vue-i18n'
const props = withDefaults(defineProps<{ status: string; unstyled?: boolean }>(), { unstyled: false })
const { t } = useI18n()

const show = computed(() => {
  return props.status === TournamentStatus.UPCOMING || props.status === TournamentStatus.RUNNING
})

const text = computed(() => {
  return t(`zoneSelection.zone.tournamentState_${props.status.toUpperCase()}`)
})
</script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.tournament-status-indicator {
  position: absolute;
  top: 0em;
  right: 0.6em;
  border-left: 1.5em solid transparent;
  border-right: 1.5em solid transparent;
  padding: 0;
  min-width: 10em;
  height: 0;
  font-size: 0.8em;
  font-weight: 700;
  line-height: 1.4em;
  color: @c0-a;
  text-align: center;
  transform-origin: 0 0;
  transform: translate(50%, -95%) rotate(45deg);
  z-index: 1;
  filter: drop-shadow(0 0.3em 0.3em rgba(0, 0, 0, 0.2));

  &:before {
    content: ' ';
    position: absolute;
    top: 1.24em;
    left: -1.4em;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0.5em 0.5em 0;
    border-color: transparent #284606 transparent transparent;
    transform: rotate(135deg);
  }

  &:after {
    content: ' ';
    position: absolute;
    top: 1.24em;
    right: -1.4em;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0.5em 0.5em 0;
    border-color: transparent #284606 transparent transparent;
    transform: rotate(135deg);
  }

  &.upcoming {
    border-bottom: 1.5em solid #e36600;
    &:before {
      border-color: transparent #762a10 transparent transparent;
    }
    &:after {
      border-color: transparent #762a10 transparent transparent;
    }
  }
  &.running {
    border-bottom: 1.5em solid #6a8f0e;
    &:before {
      border-color: transparent #284406 transparent transparent;
    }
    &:after {
      border-color: transparent #284406 transparent transparent;
    }
  }
  &.finished {
    border-bottom: 1.5em solid @c5-g;
    &:before {
      border-color: transparent @c5-i transparent transparent;
    }
    &:after {
      border-color: transparent @c5-i transparent transparent;
    }
  }
}
</style>
